import { reactive } from 'vue';

export const howlerStore = reactive({
    howlerTracks: [],
    howlerSceneTracks: {},
    howlerLibraryTracks: [],
});
